import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Message } from '@openng/optimus-ui/message';

@Component({
  selector: 'ui-message',
  imports: [Message],
  standalone: true,
  template: `
    <p-message [severity]="severity()">
      <ng-content />
    </p-message>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiMessageComponent {
  severity = input<
    'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast'
  >('info');
}
